import { ListJobOrderFragment } from 'shared/hooks/api/listJobOrderFragment/listJobOrderFragment.generated';
import { safeDateParse } from 'shared/utils/safeDateParse';
import { JobOrderApplicationProcessStatusEnum } from 'types/api.types.generated.d';
import { mapDtoToEnum } from 'types/enums/job-order-application-process-status.enum';
import { WorkTypeEnum } from 'types/enums/work-type.enum';
import { JobOrderListItem } from './JobOrderListItem';

export const mapDtoToJobOrderListItem = (dto: ListJobOrderFragment): JobOrderListItem => ({
  id: dto.jobOrderId,
  name: dto.jobOrderLabel,
  createdAt: new Date(dto.assignmentDate),
  seniority: dto.seniority ?? null,
  experienceYears: dto.experienceYears ?? null,
  locationPreference: dto.locationPreference ?? null,
  minEnglishLevel: dto.minEnglishLevel ?? null,
  workType: (dto.workMode as unknown as WorkTypeEnum) ?? null,
  matchScore: dto.score?.finalScore ?? 0,
  rateRangeFrom: dto.rateRangeFrom ?? 0,
  rateRangeTo: dto.rateRangeTo ?? 0,
  isObserved: dto.isSaved ?? false,
  application: dto.application
    ? {
        id: dto.application.applicationId,
        createdAt: new Date(dto.application.createdAt),
        meetingDates: dto.application.meetingDates
          ? dto.application.meetingDates.map((date) => new Date(date))
          : [],
        selectedMeetingDate:
          dto.application.processStatus === JobOrderApplicationProcessStatusEnum.ScheduledForCq
            ? safeDateParse(dto.application.cqDate)
            : safeDateParse(dto.application.ciDate),
        processStatus: mapDtoToEnum(dto.application.processStatus),
        meetingUrl: dto.application.meetingUrl || null,
        isViewedByExpert: dto.application.isViewedByExpert,
        preppingId: dto.application.preppingId || null,
      }
    : null,
  isAIRAvailable: dto.isAIRAvailable ?? false,
});
